<p>profile works! {{profile?.displayName}}!</p>
